import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { MultiStepStepProps } from 'components/MultiStepFlow/Types'
import { MobileInstructions } from 'flows/common/steps/BrandKitInstructions/MobileInstructions'

export const BrandKitInstructions = ({ onBack, onNext }: MultiStepStepProps) => {
  return (
    <MultiStepStepLayout onBack={onBack} onNext={onNext}>
      <MobileInstructions title="Brand Kit creates content that sounds like you" />
    </MultiStepStepLayout>
  )
}
